import React from 'react';
import { VSLHero, VSLPainSection, VSLSteps, VSLTestimonials, VSLClose } from '../components/VSL';
import { SEOHead } from '../components/SEO/SEOHead';
export function VSLPage() {
  return <>
      <SEOHead title="AcquireFlow VSL - Automated MLS Offers" description="Send 1,000+ MLS offers per day on autopilot. The ultimate tool for real estate investors." data-id="element-2875" />
      <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#3ab795] selection:text-white" data-id="element-2876">
        <VSLHero data-id="element-2877" />
        <VSLPainSection data-id="element-2878" />
        <VSLSteps data-id="element-2879" />
        <VSLTestimonials data-id="element-2880" />
        <VSLClose data-id="element-2881" />
      </div>
    </>;
}